import { useState } from "react";

import generateOptOutSearchFormSocial from "./generateOptOutSearchFormSocial";

const OptOutSearchFormSocial = ({ socialSubmit }) => {

  const [brandId, setBrandId] = useState("");
  const [social, setSocial] = useState("");

  const clearFields = () => {
    setBrandId('');
    setSocial('');
  } 
  
  return (
    <div
      className="search-form-box opt-out-search"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >

      {generateOptOutSearchFormSocial(
        brandId, setBrandId,
        social, setSocial
      )}

      <button
        onClick={() => {
            socialSubmit(social, brandId)
          } 
        }
        
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      <button
        onClick={() =>
          clearFields()
        }
        className="subBtn"
      >
        <span>Clear All Fields</span>
      </button>
    </div>
  );
};

export default OptOutSearchFormSocial;